// Copyright 2020-2023 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import useOutsideClick from "./useOutsideClick";
export default useOutsideClick;
